function initInspiratorSlider($banner) {
  var isSlickRange = $('body').hasClass('mobile');

  if (isSlickRange) {
    if (!$banner.hasClass('slick-initialized')) {
      $banner.slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true,
        dots: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  } else if ($banner.hasClass('slick-initialized')) {
    $banner.slick('unslick');
  }
}

$(function () {
  $('.inspirator').each(function () {
    const $inspiraceDiv = $(this);
    const $banner = $inspiraceDiv.find('.inspiratorInner');

    const dataUrl = $('body').hasClass('mobile')
      ? 'https://inspirator.shopcode.cz/json/collection-to-json?secure=9zq7uk9bizjdgu44fb1v'
      : ($banner.attr('data-url') || '').trim();

    if (!dataUrl) return;

    $.getJSON(dataUrl)
      .done(function (data) {
        if (data && data.length) {
          let finalHtml = '';
          let totalPoints = 0;
          data.forEach(item => {
            const imageUrl =
              item?.url && item.url.trim() !== ''
                ? item.url.replace('/upload/', '/www/upload/')
                : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/detail.png';

            let html = `
              <div class="inspirator-inner" data-id="${item.id}">
                <img src="${imageUrl}" alt="Inspirace ${item.id}">
                <ul>
            `;
            // console.log(item)
            item.points.forEach(point => {
              if (!point.product.name || point.product.name.trim() === '') return;

              totalPoints++;
              const productImage =
                point.product?.image && point.product.image.trim() !== ''
                  ? point.product.image.replace('/orig/', '/detail/')
                  : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/detail.png';

              html += `
  <li style="top: ${point.top}%; left: ${point.left}%;">
    <span class="point"></span>
    <div class="inspiraceProduct">
      <span class="close"></span>
      <div class="image">
        <img src="${productImage}" alt="${point.product.name ?? ''}">
      </div>
    <div class="wrap">
          <span class="name">${(() => {
                  const name = point.product?.name ?? '';
                  const afterDash = name.includes('-') ? name.split('-')[1] : name;
                  return afterDash.split('(')[0].trim();
                })()
                }</span>
          <span class="price">${Number(point.product?.price ?? 0).ShoptetFormatAsCurrency()}</span></div>
          <a href="${point.product?.url ?? '#'}" class="btn btn-cart add-to-cart-button">Detail</a>
    </div>
  </li>
`;
            });

            html += `
                </ul>
              </div>
            `;
            finalHtml += html;
          });

          $banner.html(finalHtml);
          $banner.attr('data-count', totalPoints);

          initInspiratorSlider($banner);
          $(window).on('resize', function () {
            initInspiratorSlider($banner);
          });
        } else {
          $inspiraceDiv.attr('data-alert', 'Data nejsou k dispozici.');
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error("Chyba při načítání JSONu:", textStatus, errorThrown);
      });
  });
});

$('html').on('click', '.inspirator-inner .point', function () {
  const $clickedLi = $(this).closest('li');
  $('body').addClass('inspiratorActive')
  $(".inspirator-inner .point").closest('li').not($clickedLi).removeClass("activeProduct");
  $clickedLi.toggleClass('activeProduct');
});

$('html').on('click', '.inspirator-inner .close', function () {
  $(this).closest('li').toggleClass('activeProduct');
  $('body').removeClass('inspiratorActive')
});
